// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1P0rG","validationTips":"StatementDescriptor_validationTips__2wwYc"};